<template>
  <v-layout>
    <v-flex>
      <v-form ref="form" v-model="valid">
        <v-text-field v-if="alert.id!==undefined" label="ID" v-model="alert.id" disabled>
        </v-text-field>
        <v-text-field label="Name" v-model="alert.name" :rules="nameRules" required>
        </v-text-field>
        <v-text-field label="Message" v-model="alert.message" :rules="messageRules" required>
        </v-text-field>
        <v-switch
          label="Alerte SMS"
          v-model="alert.isSMSActive"
          class="mx-2"
        ></v-switch>
        <v-switch
          label="Alerte Email"
          v-model="alert.isEmailActive"
          class="mx-2"
        ></v-switch>

        <div class="text-xs-right">
          <v-btn @click="submit" color="primary">Salvare</v-btn>
        </div>
      </v-form>

      <h3>Tag-uri speciale</h3>
      <p>`&lt;DATE&gt;` - Va fi inlocuit cu data de expirare</p>
      <p>`&lt;ADDRESS&gt;` - Va fi inlocuit cu data de adresa clientului.</p>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: ['alert', 'onSubmit'],
  data() {
    return {
      valid: true,
      nameRules: [
        (element) => {
          if (element.trim() === '') return 'Numele trebuie completat.';
          return true;
        },
      ],
      messageRules: [
        (element) => {
          if (element.trim() === '') return 'Mesajul trebuie completat.';

          return true;
        },
      ],
    };
  },
  methods: {
    submit() {
      if (this.$refs.form.validate() && this.valid) {
        this.onSubmit();
      }
    },
  },
};
</script>

<style>
</style>
